import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27.468px" height="22px" viewBox="0 0 27.468 22" className={props.className} onClick={props.onClick}>
            <g id="Right_arrow_Large" data-name="Right arrow – Large" transform="translate(0 -0.001)">
                <path id="Right_arrow_Large-2" data-name="Right arrow – Large" d="M-.921-43.53-2.2-42.164l8.72,8.683H-17.34v1.9H6.516L-2.2-22.9-.921-21.53l11.049-11Z" transform="translate(17.34 43.53)"/>
            </g>
        </svg>
    );
}